'use client';

import { c as _c } from "react/compiler-runtime";
import { useMemo } from 'react';
import { MultiSelectDropdown, MultiSelectOption, MultiSelectGroup } from '@/components/ui/multi-select-dropdown';
import { useGeoAreasNZ } from '@/lib/hooks/useGeoAreas';
interface NamedArea {
  postcode: string;
  name: string;
  region: string;
}
interface GeoAreaSelectProps {
  selectedAreas?: string[];
  onSelectionChange?: (geoAreaIds: string[]) => void;
  placeholder?: string;
  disabled?: boolean;
  regionFilter?: string;
  enableGrouping?: boolean;
  showChips?: boolean;
  showSummaryInTrigger?: boolean;
  maxSummaryLength?: number;
  showBulkActions?: boolean;
  label?: string | null;
  enableVirtualization?: boolean;
  showSearch?: boolean;
  searchPlaceholder?: string;
  initialSearchValue?: string;
}
export function GeoAreaSelect(t0) {
  const $ = _c(34);
  const {
    selectedAreas: t1,
    onSelectionChange,
    placeholder: t2,
    disabled: t3,
    regionFilter,
    enableGrouping: t4,
    showChips: t5,
    showSummaryInTrigger: t6,
    maxSummaryLength: t7,
    showBulkActions: t8,
    label: t9,
    enableVirtualization: t10,
    showSearch: t11,
    searchPlaceholder: t12,
    initialSearchValue: t13
  } = t0;
  let t14;
  if ($[0] !== t1) {
    t14 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t14;
  } else {
    t14 = $[1];
  }
  const selectedAreas = t14;
  const placeholder = t2 === undefined ? "Select areas..." : t2;
  const disabled = t3 === undefined ? false : t3;
  const enableGrouping = t4 === undefined ? true : t4;
  const showChips = t5 === undefined ? false : t5;
  const showSummaryInTrigger = t6 === undefined ? false : t6;
  const maxSummaryLength = t7 === undefined ? 40 : t7;
  t8 === undefined ? true : t8;
  const label = t9 === undefined ? "Areas" : t9;
  const enableVirtualization = t10 === undefined ? true : t10;
  const showSearch = t11 === undefined ? true : t11;
  const searchPlaceholder = t12 === undefined ? "Search areas..." : t12;
  const initialSearchValue = t13 === undefined ? "" : t13;
  const {
    regionsData,
    isLoading
  } = useGeoAreasNZ();
  let areas;
  if ($[2] !== regionFilter || $[3] !== regionsData) {
    areas = [];
    regionsData.forEach(regionData => {
      if (regionFilter && regionData.id !== regionFilter) {
        return;
      }
      regionData.suburbs.forEach(t15 => {
        const [postcode, name] = t15;
        areas.push({
          postcode,
          name,
          region: regionData.region
        });
      });
    });
    $[2] = regionFilter;
    $[3] = regionsData;
    $[4] = areas;
  } else {
    areas = $[4];
  }
  const allAreas = areas;
  let t15;
  bb0: {
    if (!enableGrouping) {
      let t16;
      if ($[5] !== allAreas) {
        t16 = allAreas.map(_temp);
        $[5] = allAreas;
        $[6] = t16;
      } else {
        t16 = $[6];
      }
      const opts = t16;
      let t17;
      if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t17 = [];
        $[7] = t17;
      } else {
        t17 = $[7];
      }
      let t18;
      if ($[8] !== opts) {
        t18 = {
          options: opts,
          groups: t17
        };
        $[8] = opts;
        $[9] = t18;
      } else {
        t18 = $[9];
      }
      t15 = t18;
      break bb0;
    }
    let t16;
    if ($[10] !== allAreas) {
      const regionGroups = new Map();
      allAreas.forEach(area_0 => {
        const existing = regionGroups.get(area_0.region);
        if (existing) {
          existing.push(area_0);
        } else {
          regionGroups.set(area_0.region, [area_0]);
        }
      });
      const sortedRegions = Array.from(regionGroups.entries()).sort((a, b) => {
        const regionA = allAreas.find(s => s.region === a[0])?.region || "";
        const regionB = allAreas.find(s_0 => s_0.region === b[0])?.region || "";
        return regionA.localeCompare(regionB);
      });
      const grps = [];
      const opts_0 = [];
      sortedRegions.forEach(t17 => {
        const [region, areas_0] = t17;
        const regionName = areas_0[0].region;
        grps.push({
          id: region,
          label: regionName
        });
        areas_0.sort(_temp2).forEach(area_1 => {
          opts_0.push({
            id: `${area_1.region}:${area_1.postcode}:${area_1.name}`,
            label: `${area_1.name}, ${area_1.region} ${area_1.postcode}`,
            groupId: region
          });
        });
      });
      t16 = {
        options: opts_0,
        groups: grps
      };
      $[10] = allAreas;
      $[11] = t16;
    } else {
      t16 = $[11];
    }
    t15 = t16;
  }
  const {
    options,
    groups
  } = t15;
  let t16;
  if ($[12] !== onSelectionChange) {
    t16 = selectedIds => {
      onSelectionChange?.(selectedIds);
    };
    $[12] = onSelectionChange;
    $[13] = t16;
  } else {
    t16 = $[13];
  }
  const handleSelectionChange = t16;
  if (isLoading) {
    let t17;
    if ($[14] !== label) {
      t17 = label && <label className="text-xs font-bold text-zinc-500 dark:text-zinc-500 uppercase tracking-widest block">{label}:</label>;
      $[14] = label;
      $[15] = t17;
    } else {
      t17 = $[15];
    }
    let t18;
    if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
      t18 = <div className="w-full md:w-auto min-w-[240px] px-4 py-2.5 rounded-xl bg-white dark:bg-zinc-950 border border-zinc-200 dark:border-zinc-800 text-sm font-medium text-zinc-400 dark:text-zinc-500">Loading areas...</div>;
      $[16] = t18;
    } else {
      t18 = $[16];
    }
    let t19;
    if ($[17] !== t17) {
      t19 = <div className="space-y-2">{t17}{t18}</div>;
      $[17] = t17;
      $[18] = t19;
    } else {
      t19 = $[18];
    }
    return t19;
  }
  let t17;
  if ($[19] !== disabled || $[20] !== enableVirtualization || $[21] !== groups || $[22] !== handleSelectionChange || $[23] !== initialSearchValue || $[24] !== label || $[25] !== maxSummaryLength || $[26] !== options || $[27] !== placeholder || $[28] !== searchPlaceholder || $[29] !== selectedAreas || $[30] !== showChips || $[31] !== showSearch || $[32] !== showSummaryInTrigger) {
    t17 = <MultiSelectDropdown selectableGroups={true} groupSelectionCascades={false} label={label} placeholder={placeholder} options={options} selectedIds={selectedAreas} onSelectionChange={handleSelectionChange} showChips={showChips} showSummaryInTrigger={showSummaryInTrigger} maxSummaryLength={maxSummaryLength} showBulkActions={true} disabled={disabled} groups={groups} enableVirtualization={enableVirtualization} estimateSize={40} showSearch={showSearch} searchPlaceholder={searchPlaceholder} initialSearchValue={initialSearchValue} />;
    $[19] = disabled;
    $[20] = enableVirtualization;
    $[21] = groups;
    $[22] = handleSelectionChange;
    $[23] = initialSearchValue;
    $[24] = label;
    $[25] = maxSummaryLength;
    $[26] = options;
    $[27] = placeholder;
    $[28] = searchPlaceholder;
    $[29] = selectedAreas;
    $[30] = showChips;
    $[31] = showSearch;
    $[32] = showSummaryInTrigger;
    $[33] = t17;
  } else {
    t17 = $[33];
  }
  return t17;
}
function _temp2(a_0, b_0) {
  return a_0.name.localeCompare(b_0.name);
}
function _temp(area) {
  return {
    id: `${area.region}:${area.postcode}:${area.name}`,
    label: `${area.name}, ${area.region} ${area.postcode}`
  };
}